import moment from 'moment-timezone';

/**
 * This date helper class takes care of configured timezone
 */
export class DateHelper {
  private timezone: string | undefined = undefined;

  constructor(timezone?: string) {
    this.timezone = timezone;
  }

  getTimezone() {
    return this.timezone;
  }

  setTimezone(timezone: string | undefined) {
    this.timezone = timezone;
  }

  /**
   * Use this when timeString is a utc iso string and you want to convert
   * it to the configured timezone (most likely for presentaton in the UI)
   * @param timeString utc iso string or undefined (undefined is equivalent to 'now')
   */
  date(timeString: string | undefined): moment.Moment {
    return this.timezone ? moment(timeString).tz(this.timezone) : moment(timeString);
  }

  /**
   * Use this when a formatted date string is given as input which should be considered
   * as given in a configured timezone (has no timezone indicador in the string itself).
   * example: '30/10/2022 10:55'
   * @param formattedDateString formatted date string
   */
  dateFromFormattedString(formattedDateString: string) {
    return this.timezone ? moment.tz(formattedDateString, this.timezone) : moment(formattedDateString);
  }

  /**
   * Returns a moment date object from the given time in milliseconds since epoch
   */
  dateFromMilliseconds(ms: number) {
    return this.timezone ? moment(ms).tz(this.timezone) : moment(ms);
  }
}
